import type { TOC } from '@ember/component/template-only';
import type VisitComposite from 'garaje/models/visit-composite';

import TimeCell from './time-cell';

interface SignOutTimeCellSignature {
  Args: {
    row: VisitComposite;
  };
}

export default <template>
  <TimeCell @time={{@row.signOutTime}} @locationTimezone={{@row.locationTimezone}} />
</template> satisfies TOC<SignOutTimeCellSignature>;
